import React, { Component } from 'react'
import config from '../../resource/config.js'

const inlineEditingApi = config.apiBaseUrl + 'apbe/inlineEditing'

class InlineEditingModal extends Component {
    constructor(props) {
        super(props)
        this.finalSubmit = this.finalSubmit.bind(this)
        this.state = { data: 'false', cognitoId: '', reqId: '', isLoading: true }
        this.modalId = `${this.props.triggerId.replace('Trigger', '')}Container`
    }

    finalSubmit() {
        window.onbeforeunload = null
        let data = [...this.props.editedStagingData]
        let requestData = []
        //just sending the updated records and dup records to the backend to be fully validated
        data.forEach(row => {
            if (row.ROW_UPDATED) {
                let keys = Object.keys(row)
                keys.forEach(key => {
                    if (key.includes('_ORIGIN')) {
                        delete row[key]
                    }
                    if (key.includes('_UI_ERRORS')) {
                        delete row[key]
                    }
                })
                requestData.push(row)
            } else {
                if (row.IS_DUPLICATE) {
                    requestData.push(row)
                }
            }
        })
        //console.log('request data:', requestData)
        const requestBody = {
            stagingData: requestData,
            deleteStagingData: this.props.deletedStagingData,
            request: this.props.request
        }
        fetch(inlineEditingApi, {
            method: 'POST',
            dataType: 'jsonp',
            headers: this.props.apiAuthHeaders,
            body: JSON.stringify(requestBody)
        }).then((response) => {
            return response.json()
        }).then((responseData) => {
            console.log('inlineEditing responseData:', responseData)
            window.location.replace("/")
            this.setState({ isLoading: false })
        }).catch(function (err) {
            console.log(err)
        })

    }

    componentDidMount() {
        const triggerElement = document.getElementById(this.props.triggerId)
        if (triggerElement) {
            window.cb.apricot.CBModal.init({
                elem: triggerElement,
                targetElem: this.modalId,
            })
        }
    }

    render() {
        return (
            <div className="submitModal">
                <div id={this.modalId} className="cb-modal" aria-hidden="true">
                    <div className="cb-modal-overlay" tabIndex="-1" data-cb-modal-close>
                        <div className="cb-modal-container" role="dialog" aria-modal="true"
                             aria-labelledby={`${this.modalId}Title`}>
                            <div className="cb-modal-header cb-modal-has-close">
                                <h2 className="cb-modal-title" id={`${this.modalId}Title`}>Confirm
                                    Revalidation</h2>
                                <button type="button" className="cb-btn cb-btn-square cb-btn-greyscale cb-btn-close"
                                        aria-describedby={`${this.modalId}Title`} data-cb-modal-close>
                                    <span className="cb-glyph cb-x-mark" aria-hidden="true"></span>
                                    <span className="sr-only">Close</span>
                                </button>
                            </div>
                            <div className="cb-modal-content">
                                <p>Are you sure you want to save your changes and revalidate your data?</p>
                                <p>Click <strong>Yes</strong> to continue. Click <strong>No</strong> to continue
                                    reviewing errors and
                                    warnings.</p>
                            </div>
                            <div className="cb-modal-footer">
                                <div className="cb-btn-row">
                                    <button type="button" className="btn btn-naked btn-sm" data-cb-modal-close>NO
                                    </button>
                                    <button type="button" className="btn btn-primary btn-sm cb-margin-left-16"
                                            data-cb-modal-close
                                            onClick={this.finalSubmit}>YES
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default InlineEditingModal
